export const HELP = {
  GRIDCOLUMNS_help_libaryNotation_license: 'GRIDCOLUMNS_help_libaryNotation_license',
};
